module.exports = __webpack_public_path__ + "images/assets/267688a232ce65d8ed3ece6a83f04c59.svg";